"use strict";

// ===== AdminLTE3 Dependencies =====
// jQuery をグローバルにする
window.$ = window.jQuery = $;

import "ekko-lightbox";
import "ekko-lightbox/dist/ekko-lightbox.css";

import "bootstrap-switch";
import "./bootstrap.js";

import moment from "moment";
window.moment = moment;

// ----- AdminLTE3
import "admin-lte";

// ===== AdminLTE3 Plugins =====
import "chart.js";
import "jquery-mousewheel";
import "raphael";
//import 'flot';
import "bootstrap4-duallistbox";
import "bs-custom-file-input";
import "datatables.net-autofill";
import "datatables.net-bs4";
import "datatables.net-buttons";
import "datatables.net-colreorder";
import "datatables.net-fixedcolumns";
import "datatables.net-fixedheader";
import "datatables.net-keytable";
import "datatables.net-responsive";
import "datatables.net-rowgroup";
import "datatables.net-rowreorder";
import "datatables.net-scroller";
import "datatables.net-select";
import "daterangepicker";
import "fastclick";
import "inputmask";
import "ion-rangeslider";
import "jquery-knob-chif";
import "jquery-validation";
import "jsgrid";
import "overlayscrollbars";
import "select2";
import "tempusdominus-bootstrap-4";
import "toastr";
// import 'pace-js';
import "filterizr";
